import { Modal, ModalOverlay, ModalContent, ModalBody, Button, Flex, Text } from '@chakra-ui/react'
import Link from 'next/link'
import GearImage from '@/public/assets/images/common/gear-image.png'
import Image from 'next/image'

export const MaintenanceModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal isCentered={true} size={'sm'} isOpen={true} closeOnEsc={false} closeOnOverlayClick={false} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalBody pb={5}>
          <Flex pb={4} pt={6} textAlign={'center'} flexDir={'column'} alignItems={'center'}>
            <Image src={GearImage} alt="" />
            <Text mb={1} mt={3} lineHeight={1.1} fontSize={'xl'} fontWeight={700}>
              The game is unavailable as technical work is underway
            </Text>
            <Text mb={5} fontSize={'xs'} color={'ninja.100'} fontWeight={500}>
              We apologize for any inconvenience
            </Text>
            <Button rounded={'xl'} variant={'secondary'} as={Link} href={'/'}>
              Go to Main Page
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
